import { Input } from "../../components";
import { ValidationErrors } from "./ValidationErrors";
import cn from "classnames";
import sharedStyles from "./shared.module.scss";

export function ValidatedInput({
  label,
  id,
  name,
  className,
  onChange,
  onBlur,
  type,
  value,
  errors,
  pristine,
  loading,
}) {
  const showErrors = !pristine && errors.length !== 0;
  return (
    <>
      <Input
        label={label}
        id={id}
        name={name}
        type={type}
        onChange={onChange}
        onBlur={onBlur}
        value={value}
        labelClassName={showErrors && sharedStyles.errorLabel}
        className={cn(showErrors && sharedStyles.errorBorder, className)}
        loading={loading}
      />
      {!pristine && (
        <div className={cn(showErrors && sharedStyles.errorsBox)}>
          <ValidationErrors errors={errors} />
        </div>
      )}
    </>
  );
}
